import ImgLogo from 'assets/img/logo/logo-page.png';
import React from 'react';
import './Logo.styles.scss';

const Logo = () => {
  return (
    <React.Fragment>
      <img src={ImgLogo} className="img-logo-principal" alt="" loading="lazy" />
    </React.Fragment>
  );
};

export default Logo;
